import { render, staticRenderFns } from "./myRobotChat.vue?vue&type=template&id=6c723b38&"
import script from "./myRobotChat.vue?vue&type=script&lang=js&"
export * from "./myRobotChat.vue?vue&type=script&lang=js&"
import style0 from "./myRobotChat.vue?vue&type=style&index=0&id=6c723b38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports